<footer class="footerColors">
    {{footerText}}
</footer>